import React, { useEffect, useState } from 'react';
import { PhoneIcon } from 'lucide-react';
interface NavbarProps {
  ctaHref?: string;
  showActions?: boolean;
}
export function Navbar({
  ctaHref = '#consultation-form',
  showActions = true
}: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-50 w-full transition-all duration-300 ${isScrolled ? 'bg-[var(--color-navy)]/98 py-2 shadow-lg backdrop-blur-sm' : 'bg-[var(--color-navy)] py-4'}`} data-id="element-92" data-mp="11hgw9cw060of">
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between gap-4 px-4 sm:px-6 lg:px-8" data-id="element-93" data-mp="1ajgdo6axj6rw">
        <div className="flex shrink-0 select-none items-center" aria-label="Mannix Marketing logo" data-id="element-94" data-mp="2hxjk92cfx9dr">
          <img src="https://cdn.magicpatterns.com/uploads/nkgpkTDoajFMzoroTLsiW3/mannix-marketing.png" alt="Mannix Marketing" className="h-10 w-auto object-contain sm:h-12" data-id="element-95" data-mp="2lz54x9v7uryi" />
        </div>
        {showActions && <div className="flex items-center gap-2 sm:gap-4" data-id="element-96" data-mp="29rnpbrg81bje">
            <a href="tel:5186560527" className="flex items-center gap-2 rounded-full bg-[var(--color-lime)] px-3 py-2 text-xs font-bold text-[var(--color-navy)] transition-colors hover:bg-[var(--color-lime-dark)] sm:px-5 sm:py-2.5 sm:text-sm" data-id="element-97" data-mp="24tccr8yjkmxh">
              <PhoneIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-98" data-mp="1vvsca28i6unx" />
              <span className="hidden xs:inline sm:inline" data-id="element-99" data-mp="1r15vfjjnk9wg">518-656-0527</span>
            </a>
            <a href={ctaHref} className="hidden items-center rounded-full bg-white px-5 py-2.5 text-sm font-bold text-[var(--color-navy)] transition-colors hover:bg-slate-100 sm:flex" data-id="element-100" data-mp="1m4fgizjl3kcm">
              Schedule Your Free Consultation
            </a>
            <a href={ctaHref} className="flex items-center rounded-full bg-white px-3 py-2 text-xs font-bold text-[var(--color-navy)] transition-colors hover:bg-slate-100 sm:hidden" data-id="element-101" data-mp="183uza7tbhwl8">
              Free Consult
            </a>
          </div>}
      </div>
    </header>;
}